import { useState } from 'react';
import { useLang } from '../context/LanguageContext';

const AgeInputStep = ({ value, onSave }) => {
  const [age, setAge] = useState(value || '');
  const { t } = useLang();
  const isValid = parseInt(age) > 0 && parseInt(age) < 120;

  return (
    <div className="max-w-md mx-auto">
      <input
        type="number"
        value={age}
        onChange={(e) => setAge(e.target.value)}
        placeholder={t('enterYourAge')}
        className="w-full px-4 py-4 bg-[#1a1b1e] border border-[#2a2b2f] focus:border-[#ff4e15] outline-none rounded-sm text-white text-lg font-medium transition-colors text-center"
        data-testid="age-input"
      />
      <button
        onClick={() => onSave(age)}
        disabled={!isValid}
        className={`mt-8 w-full py-3.5 rounded-sm font-bold uppercase tracking-wide transition-all ${
          !isValid
            ? 'bg-[#2a2b2f] text-white/40 cursor-not-allowed'
            : 'bg-[#ff4e15] hover:bg-[#ff6033] text-white pulse-orange'
        }`}
        data-testid="age-continue-btn"
      >
        {t('continue')}
      </button>
    </div>
  );
};

export default AgeInputStep;
